<script>
  import {onDestroy} from 'svelte';
  import {writable, derived} from 'svelte/store';
  import firebase from 'firebase';

  export let userId;

  let unsubscriber = null;

  const userIdStore = writable(null);
  const user = derived(
      userIdStore,
      ($userIdStore, set) => {
        unsubscriber && unsubscriber();

        if ($userIdStore) {
          unsubscriber = firebase.firestore()
                  .collection('users')
                  .doc($userIdStore)
                  .onSnapshot(snapshot => set(snapshot));
        } else {
          unsubscriber = null;
        }
      }
  );

  $: userIdStore.set(userId);

  onDestroy(() => unsubscriber && unsubscriber());
</script>

<slot item={$user}/>

